import { all, call, delay, spawn } from 'redux-saga/effects';
import { fetchBookingFlow, fetchMultipleBookingFlow } from './fetchBookingFlow';
import { fetchLocationsFlow } from './fetchLocationsFlow';
import { fetchDepotsFlow } from './fetchDepotsFlow';
import { fetchDepotAssetsFlow } from './fetchDepotAssetsFlow';
import { fetchDoorStatusFlow } from './fetchDoorStatusFlow';
import { enqueueSnackbarFlow } from './enqueueSnackbarFlow';
import { openDoorFlow } from './openDoorFlow';
import Logger from '../common/logger';
import { updateLocationFlow } from './updateLocationFlow';
import { fetchThingsFlow } from './fetchThingsFlow';
import { restartDepotFlow } from './restartDepotFlow';
import { rebookCustomerDoorFlow } from './rebookCustomerDoorFlow';
import { finishRentalFlow } from './finishRentalFlow';
import { startRentalFlow } from './startRentalFlow';
import { fetchLocationBookingStatsFlow } from './fetchLocationBookingStatsFlow';
import { fetchIssueReportsFlow } from './fetchIssueReportsFlow';
import { createIssueReportFlow } from './createIssueReport';
import { updateIssueReportStatusFlow } from './updateIssueReportStatus';
import {fetchAssetGroupsFlow} from './fetchAssetGroupsFlow';
import {fetchLocationAvailabilitiesFlow} from './fetchLocationAvailabilities';
import {createNewOrderFlow} from './createOrderFlow';
import { fetchVisitorBookingsFlow } from './fetchVisitorBookingsFlow';
import { fetchAssetForIssueReportsFlow } from './fetchAssetsFlow';

/**
 * Prevents the root saga from terminating entirely due to some error in another saga
 *
 * @param saga
 */
const makeRestartable = (saga: any) => {
    return function* () {
        yield spawn(function* () {
            while (true) {
                try {
                    yield call(saga);
                    Logger('Root Saga').error(
                        'Unexpected root saga termination. The root sagas should live during the whole app lifetime!',
                        saga,
                    );
                } catch (e) {
                    Logger('Root Saga').error(
                        'Saga error, the saga will be restarted',
                        e,
                    );
                }
                yield delay(1000); // Workaround to avoid infinite error loops
            }
        });
    };
};

const rootSagas: any = [
    fetchBookingFlow,
    fetchMultipleBookingFlow,
    fetchVisitorBookingsFlow,
    fetchLocationsFlow,
    fetchDepotsFlow,
    fetchDepotAssetsFlow,
    fetchThingsFlow,
    fetchIssueReportsFlow,
    fetchDoorStatusFlow,
    enqueueSnackbarFlow,
    openDoorFlow,
    updateLocationFlow,
    restartDepotFlow,
    rebookCustomerDoorFlow,
    finishRentalFlow,
    startRentalFlow,
    fetchLocationBookingStatsFlow,
    createIssueReportFlow,
    updateIssueReportStatusFlow,
    fetchAssetGroupsFlow,
    fetchLocationAvailabilitiesFlow,
    createNewOrderFlow,
    fetchAssetForIssueReportsFlow,
].map(makeRestartable);

export default function* rootSaga() {
    Logger('Root Saga').log('root saga started');
    yield all(rootSagas.map((saga: any) => call(saga)));
}
